import { PayrollProcessingSystemId, PayrunListItem, PayrunTypes } from '@xemplo/gp-types';
import {
  DawnCalendar,
  DawnCalendarSearch,
  LogoVariant,
  LogoXemploMark,
} from '@xemplo/icons';
import { SvgStroke } from '@xemplo/style-constants';

import * as S from '../payrun-base-table.styles';

export function PayrunNameCell(props: { payrun: PayrunListItem }) {
  const { name, payrunTypeId, payrollProcessingSystemId } = props.payrun;
  const isAdhoc = payrunTypeId === PayrunTypes.ADHOC;
  const isXemploPay = payrollProcessingSystemId === PayrollProcessingSystemId.XemploPay;
  return (
    <S.PayrunNameCell>
      <S.PayrunIcon className={isAdhoc ? 'adhoc' : undefined}>
        {isAdhoc ? (
          <DawnCalendarSearch strokeWidth={SvgStroke.Light} />
        ) : (
          <DawnCalendar strokeWidth={SvgStroke.Light} />
        )}
        {isXemploPay && (
          <S.PayrunSystemBadge role="img" aria-label="XemploPay pay run">
            <LogoXemploMark variant={LogoVariant.xemplo} />
          </S.PayrunSystemBadge>
        )}
      </S.PayrunIcon>
      <S.PayrunNameContent>
        <div>{name}</div>
        <S.PayrunTypeLabel>{isAdhoc ? 'Ad Hoc' : 'Pay Schedule'}</S.PayrunTypeLabel>
      </S.PayrunNameContent>
    </S.PayrunNameCell>
  );
}
